module.exports = __webpack_public_path__ + "static/media/london.841651c3.jpg";